import { ContentContainer } from "components/common";

const Ethics = () => {
    return (
        <ContentContainer>
            <p className="text-lg text-justify">
                Many of the historical images we are working with are terribly degrading and dehumanizing, especially
                the images of people of color. Although some of the tradecards and postcards can be shocking from a
                contemporary perspective, they were normalized in the late-1800s and early-1900s. While disturbing to
                look at, we strongly believe that this archive of racism and sexism is important to study, in order to
                understand how the visual culture of domestic labor was shaped in the period of New Imperialism, Jim
                Crow racism, Asian Exclusion, especially given the marginalization of domestic workers from the
                anti-colonial, women&apos;s suffrage, and trade union movements of the time. We have historically
                contextualized the images, and blurred some of the extremely degrading images, providing users the
                choice to view them (or not) by clicking on them.
            </p>
            <p className="mt-4 text-lg">
                As you go though the digital exhibition, we would urge you to reflect on the following questions, that
                we are also grappling over as we are curating and creating this digital history project:
            </p>
            <ul className="list-disc pl-5 mt-4 text-lg">
                <li>
                    Does reproducing racist and sexist historical images (even in academic spaces) perpetuate histories
                    of degradation, marginalization, and trauma? How do we avoid it?
                </li>
                <li>How do we censor certain images without “sanitizing” racism of the past?</li>
                <li>
                    How do we historicize racist and sexist humor? How do we ensure that contemporary viewers do not
                    find them funny?
                </li>
                <li>
                    How can the tradecards and postcards of domestic workers (mostly women of color) be used to generate
                    critical conversations about not only colonial capitalism but also contemporary neoliberal
                    capitalism’s exploitation of gendered domestic labor? Afterall, domestic labor in the Global North
                    today is largely performed by women of color and immigrant women from the Global South (formerly
                    colonized places)
                </li>
                <li>
                    How can historians use degrading dehumanizing historical images as teaching tools to foster
                    anti-racism, feminism, and social justice?
                </li>
            </ul>
        </ContentContainer>
    );
};

export default Ethics;
